import { FaPlayCircle } from "react-icons/fa"

export const PlayIcon = props => {
  return <FaPlayCircle {...props} />
}
